import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const FederalAgencyChart = ({ agencies }) => {
  const data = {
    labels: agencies.map((a) => a.agency),
    datasets: [
      {
        label: "% of Federal Land",
        data: agencies.map((a) => a.percent),
        backgroundColor: "#CC0000",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
      title: {
        display: true,
        text: "Federal Land Management Agencies",
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y}%`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Agency",
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "% of Utah Land",
        },
      },
    },
  };

  return (
    <div className="bg-white p-8 shadow-xl rounded-xl mb-16">
      <div className="w-full h-[460px]">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default FederalAgencyChart;